import { forwardRef, Ref } from 'react'

export const WrapImage = forwardRef(
  (props: { children?: any }, ref: Ref<HTMLDivElement>) => (
    <div ref={ref}>{props.children}</div>
  )
)
